/**
 * Quyền của module `audit` (Nhật ký & Truy vết, ADR-0095 mục 4) — thay `quyen.ts` của native (sáu nhóm `AUDIT_*`, bốn
 * vai `audit_*`). Thẻ "Nhật ký sử dụng AI" của Cài đặt bảo mật hiện theo dịch vụ `nhat-ky-truy-vet` trong gói; trong
 * thẻ, phần kỹ thuật gác bằng mã `audit:*` dưới đây. Không đủ quyền thì ẨN (ADR-UI-0005). Máy chủ kiểm lại mọi lượt —
 * đây chỉ là chuyện hiện hay không. Khai đủ mọi mã của manifest để `quyen-pham-vi.ts` tính phạm vi như máy chủ.
 */
import { useModulePermissions } from '../../hooks/usePermission';

export const QUYEN_AUDIT = {
  tongQuan: 'audit:tong-quan:read',
  suKien: 'audit:su-kien:read',
  xuat: 'audit:su-kien:export',
  suDungAi: 'audit:su-dung-ai:read',
  canhBao: 'audit:canh-bao:read',
  canhBaoSua: 'audit:canh-bao:update',
  cauHinh: 'audit:cau-hinh:read',
  cauHinhThem: 'audit:cau-hinh:create',
  cauHinhSua: 'audit:cau-hinh:update',
  cauHinhXoa: 'audit:cau-hinh:delete',
  kyThuat: 'audit:ky-thuat:read',
  vaiQuanTri: 'audit:vai:quan-tri',
  vaiThanhTra: 'audit:vai:thanh-tra',
  vaiTruongDonVi: 'audit:vai:truong-don-vi',
} as const;

export type QuyenAudit = Record<keyof typeof QUYEN_AUDIT, boolean>;

/** Mọi cờ quyền `audit:*` của người đăng nhập một lần. */
export function useQuyenAudit(): QuyenAudit {
  return useModulePermissions(QUYEN_AUDIT);
}
